import { render } from "./SideNav.vue?vue&type=template&id=05858e3e"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/SideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05858e3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05858e3e', __exports__)) {
    api.reload('05858e3e', __exports__)
  }
  
  module.hot.accept("./SideNav.vue?vue&type=template&id=05858e3e", () => {
    api.rerender('05858e3e', render)
  })

}


export default __exports__